import type { SellerApplicationStatus } from './api';

const REVISION_PHRASE = 'требуется редактирование';

/** Совпадает с проверкой на бэкенде (`seller-application-revision.util.ts`). */
export function isModerationRevisionRejection(reason: string | null | undefined): boolean {
  return (reason ?? '').toLowerCase().includes(REVISION_PHRASE);
}

export function sellerNeedsRevisionRegistrationWizard(
  status: SellerApplicationStatus,
  moderationRejectionReason: string | null | undefined,
  moderationRejectionKind?: string | null,
): boolean {
  if (status !== 'REJECTED') return false;
  if (moderationRejectionKind != null && moderationRejectionKind !== '') return true;
  return isModerationRevisionRejection(moderationRejectionReason);
}
